// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let AlertsDropdown = require("../AlertsDropdown.bs.js");
let TailwindMerge = require("tailwind-merge");
let ProfileDropdown = require("../../reason/components/ProfileDropdown.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let HeaderSearchDropdown = require("../../reason/components/HeaderSearchDropdown.bs.js");
let LogoMobileSvg = require("../../../assets/images/logos/logo-mobile.svg");
let LogoDesktopSvg = require("../../../assets/images/logos/logo-desktop.svg");

let logoDesktop = LogoDesktopSvg;

let logoTablet = LogoMobileSvg;

function Header$LogoMobile(props) {
  let logoFillColor = props.topNavIsOpened ? "#1b3549" : "#909294";
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsxs("g", {
      children: [
        JsxRuntime.jsx("polygon", {
          id: "Shape",
          fill: "#1b3549",
          points: "20.257 10.963 23.48 10.963 16.684 0 9.889 10.963 13.112 10.963 16.684 5.2"
        }),
        JsxRuntime.jsx("path", {
          id: "Shape",
          d: "M26.776,16.28 L25.078,13.541 L8.291,13.541 L6.593,16.28 L26.776,16.28 Z M30.073,21.598 L28.374,18.858 L4.994,18.858 L3.296,21.598 L30.073,21.598 Z M33.369,26.915 L31.671,24.176 L1.698,24.176 L0,26.915 L33.369,26.915 Z",
          fill: logoFillColor
        })
      ],
      id: "logo-mobile",
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }),
    className: "hidden-print",
    height: "27px",
    width: "34px",
    viewBox: "0 0 34 27"
  });
}

let LogoMobile = {
  make: Header$LogoMobile
};

function Header$HeaderLogo(props) {
  if (!props.isLoggedIn) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("a", {
        children: JsxRuntime.jsxs("picture", {
          children: [
            JsxRuntime.jsx("source", {
              media: "(min-width: 1200px)",
              srcSet: logoDesktop
            }),
            JsxRuntime.jsx("img", {
              alt: "logo",
              src: logoTablet
            })
          ]
        }),
        href: "/"
      }),
      className: "flex flex-row"
    });
  }
  let mobileNavToggle = props.mobileNavToggle;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("a", {
          children: JsxRuntime.jsxs("picture", {
            children: [
              JsxRuntime.jsx("source", {
                media: "(min-width: 1200px)",
                srcSet: logoDesktop
              }),
              JsxRuntime.jsx("img", {
                alt: "logo",
                src: logoTablet
              })
            ]
          }),
          href: props.userRole === "client" ? "/client" : "/"
        }),
        className: "sm:block hidden"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Header$LogoMobile, {
            topNavIsOpened: props.topNavIsOpened
          }),
          className: "flex",
          onClick: param => mobileNavToggle()
        }),
        className: "block sm:hidden"
      })
    ],
    className: "flex flex-row"
  });
}

let HeaderLogo = {
  make: Header$HeaderLogo
};

function Header(props) {
  let topNavIsOpened = props.topNavIsOpened;
  let mobileNavToggle = props.mobileNavToggle;
  let userRole = props.userRole;
  let isLoggedIn = props.isLoggedIn;
  return JsxRuntime.jsx("header", {
    children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
      children: JsxRuntime.jsx("div", {
        children: isLoggedIn ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Header$HeaderLogo, {
                mobileNavToggle: mobileNavToggle,
                topNavIsOpened: topNavIsOpened,
                isLoggedIn: isLoggedIn,
                userRole: userRole
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    userRole === "agent" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx(HeaderSearchDropdown.make, {}),
                          JsxRuntime.jsx(AlertsDropdown.make, {})
                        ]
                      }) : null,
                    JsxRuntime.jsx(ProfileDropdown.make, {
                      handleSignout: props.handleSignout
                    })
                  ],
                  className: "flex items-center self-stretch relative"
                }),
                className: "flex items-center self-stretch"
              })
            ]
          }) : JsxRuntime.jsx(Header$HeaderLogo, {
            mobileNavToggle: mobileNavToggle,
            topNavIsOpened: topNavIsOpened,
            isLoggedIn: isLoggedIn,
            userRole: userRole
          }),
        className: "items-center flex justify-between h-[67px]"
      })
    }),
    className: TailwindMerge.twMerge([
      "bg-white",
      isLoggedIn ? "border-b border-zinc-300" : ""
    ])
  });
}

let make = Header;

exports.logoDesktop = logoDesktop;
exports.logoTablet = logoTablet;
exports.LogoMobile = LogoMobile;
exports.HeaderLogo = HeaderLogo;
exports.make = make;
/* logoDesktop Not a pure module */
